import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-validation-display',
  templateUrl: './validation-display.component.html',
  styleUrls: ['./validation-display.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ValidationDisplayComponent implements OnInit {
  private genericMessages = {
    required: 'This field is required',
    pattern: 'Invalid input',
    minLengthArray: 'Minumum required number of elements is %minLengthArray%',
    maxLengthArray: 'Minumum required number of elements is %maxLengthArray%',
    min: 'Minimum allowed value for this field is %min.min%',
    max: 'Maximum allowed value for this field is %max.max%',
    error: '%error%'
  };

  private oldStatusChangedSubscription: Subscription;
  public _control: AbstractControl;
  public get control(): AbstractControl {
    return this._control;
  }
  @Input()
  public set control(val: AbstractControl) {
    if (this.oldStatusChangedSubscription) {
      this.oldStatusChangedSubscription.unsubscribe();
    }

    this._control = val;
    this.update();
    this.oldStatusChangedSubscription = this.control.statusChanges.subscribe(_ => this.update());
  }

  @Input()
  public errorMessage: string;

  @Input()
  public showImmediately: boolean;

  public message: string;

  constructor() {}

  getMessage(errId: string, userDefinedErrorMessage: string, errorsObj: any) {
    // start with generic message
    let message: string = userDefinedErrorMessage || this.genericMessages[errId] || errId;
    // replace placeholders
    message = message.replace(/%[A-z.]*%/, function(match, capture) {
      // navigate path in placeholder, starting from errorsObj
      const path = match.substring(1, match.length - 1);
      const elements = path.split('.');
      let curr = errorsObj;
      elements.forEach(el => {
        curr = curr[el];
        // if path does not resolve to a property under errorsObj, leave it as is (do not replace it).
        if (curr === undefined) {
          return path;
        }
      });
      return curr;
    });
    return message;
  }

  update() {
    if (this.control.errors) {
      this.message =
        Object.keys(this.control.errors || {})
          .map(k => this.getMessage(k, this.errorMessage, this.control.errors) || `Validation error: ${k}`)
          .reduce((agg, val) => `${agg}${val}\n`, '').trim();
    } else {
      this.message = '';
    }
  }

  ngOnInit() {
    this.update();
  }
}
